import { Card } from "@atoms";
import { Skeleton } from "@molecules";

type PersonPageSkeletonProps = {
  hasConnectionButton: boolean;
};

export const PersonPageSkeleton = ({ hasConnectionButton }: PersonPageSkeletonProps) => {
  return (
    <>
      <Card className="bg-beige-200 py-8 px-6 grid grid-cols-[auto_1fr_auto] items-center gap-4">
        <Skeleton className="size-16 rounded-full" />
        <Skeleton className="h-8 w-48" />
        {hasConnectionButton && <Skeleton className="h-9 w-32" />}
      </Card>

      <Card className="grid grid-cols-[repeat(7,minmax(0,auto))] sm:grid-cols-7 justify-between gap-x-2 sm:gap-x-6 md:gap-x-8 px-4 md:px-8 rounded-none sm:rounded-lg+ overflow-clip">
        <div className="grid col-span-full md:max-w-[240px] grid-cols-[auto_1fr_auto] gap-8 md:gap-2 items-center py-4 md:py-8">
          <Skeleton className="size-8 order-1 md:ml-auto md:order-2" />
          <Skeleton className="h-6 w-24 justify-self-center md:justify-self-start order-2 md:order-1" />
          <Skeleton className="size-8 order-3" />
        </div>

        <hr className="col-span-full -mx-4 md:-mx-8" />

        {Array.from({ length: 7 }, (_, i) => {
          return (
            <div
              key={i}
              className="flex flex-col gap-2 items-center sm:items-start py-4">
              <Skeleton className="h-3 w-6" />
              <Skeleton className="h-4 w-5" />
              <Skeleton className="size-8 md:size-10" />
            </div>
          );
        })}

        <hr className="col-span-full -mx-4 md:-mx-8" />

        <div className="col-span-full flex flex-col gap-5 py-4 md:py-8">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-[94px] w-full rounded-lg" />
        </div>
      </Card>
    </>
  );
};
